export const allColumns =[
      { name: 'cusip', key: 'cusip', isSelected: false, order: 1, isDefault: false },
      { name: 'issuer', key: 'issuer', isSelected: false, order: 2, isDefault: false },
      { name: 'coupon', key: 'cusipCoupon', isSelected: false, order: 3, isDefault: false },
      { name: 'state', key: 'stateName', isSelected: false, order: 4, isDefault: false },
      { name: 'bond insurer', key: 'bondInsurer', isSelected: false, order: 5, isDefault: false },
      { name: 'call date', key: 'callDate', isSelected: false, order: 6, isDefault: false },
      { name: 'maturity date', key: 'maturityDate', isSelected: false, order: 7, isDefault: false },
      { name: 'settlement date', key: 'settleDate', isSelected: false, order: 8, isDefault: false },
      { name: 'ecn', key: 'ecn', isSelected: false, order: 9, isDefault: false },
      { name: 'collection details', key: 'bidBy', isSelected: false, order: 10, isDefault: false },
      { name: 'status', key: 'status', isSelected: false, order: 11, isDefault: false },
      { name: 'idc price', key: 'idcPrice', isSelected: false, order: 12, isDefault: false },
      { name: 'price', key: 'price', isSelected: true, order: 13, isDefault: true },
      { name: 'yield', key: 'yield', isSelected: true, order: 14, isDefault: true },
      { name: 'spread', key: 'spread', isSelected: true, order: 15, isDefault: true },
      { name: 'quantity', key: 'quantity', isSelected: true, order: 16, isDefault: true },
      { name: 'action', key: 'action', isSelected: true, order: 17, isDefault: true },
      { name: 'assigned to', key: 'assigned to', isSelected: false, order: 18, isDefault: false },
      { name: 'issuer', key: 'issuer', isSelected: false, order: 19, isDefault: false },
      { name: 'proceeds', key: 'proceeds', isSelected: false, order: 20, isDefault: false },
      { name: 'min Denom', key: 'minDenom', isSelected: false, order: 21, isDefault: false },
      { name: 'muni sec type', key: 'muniSecType', isSelected: false, order: 22, isDefault: false },
      { name: 'fed tax status', key: 'federalTaxStatus', isSelected: false, order: 23, isDefault: false },
      { name: 'state tax status', key: 'stateTaxStatus', isSelected: false, order: 24, isDefault: false },
      { name: 'put indicator', key: 'putIndicator', isSelected: false, order: 25, isDefault: false },
      { name: 'issue date', key: 'issueDate', isSelected: false, order: 26, isDefault: false },
      { name: 'sink indicator', key: 'sinkIndicator', isSelected: false, order: 27, isDefault: false },
      {
            "name": "S&P Rating",
            "key": "ratingSP",
            "isSelected": false,
            "order": 28,
            "isDefault": false
        }
    ]
    export const defaultColumns =[
      { name: 'cusip', key: 'cusip', isSelected: true, order: 1, isDefault: false },
      { name: 'issuer', key: 'issuer', isSelected: true, order: 2, isDefault: false },
      { name: 'coupon', key: 'cusipCoupon', isSelected: true, order: 3, isDefault: false },
      { name: 'state', key: 'stateName', isSelected: true, order: 4, isDefault: false },
      { name: 'bond insurer', key: 'bondInsurer', isSelected: true, order: 5, isDefault: false },
      { name: 'call date', key: 'callDate', isSelected: true, order: 6, isDefault: false },
      { name: 'maturity date', key: 'maturityDate', isSelected: true, order: 7, isDefault: false },
      { name: 'settlement date', key: 'settleDate', isSelected: true, order: 8, isDefault: false },
      { name: 'ecn', key: 'ecn', isSelected: true, order: 9, isDefault: false },
      { name: 'collection details', key: 'bidBy', isSelected: true, order: 10, isDefault: false },
      { name: 'status', key: 'status', isSelected: true, order: 11, isDefault: false },
      { name: 'idc price', key: 'idcPrice', isSelected: true, order: 12, isDefault: false },
      { name: 'price', key: 'price', isSelected: true, order: 13, isDefault: true },
      { name: 'yield', key: 'yield', isSelected: true, order: 14, isDefault: true },
      { name: 'spread', key: 'spread', isSelected: true, order: 15, isDefault: true },
      { name: 'quantity', key: 'quantity', isSelected: true, order: 16, isDefault: true },
      { name: 'action', key: 'action', isSelected: true, order: 17, isDefault: true },
      { name: 'assigned to', key: 'assigned to', isSelected: true, order: 18, isDefault: false }
    ]    
export const sortableColumns = [
      { name: 'cusip', key: 'cusip' },
      { name: 'coupon', key: 'cusipCoupon' },
      { name: 'state', key: 'stateName' },
      { name: 'bond insurer', key: 'bondInsurer' },
      { name: 'call date', key: 'callDate'},
      { name: 'maturity date', key: 'maturityDate'},
      { name: 'settlement date', key: 'settleDate'},
      { name: 'ecn', key: 'ecn', },
      { name: 'collection details', key: 'bidBy'},
      { name: 'status', key: 'status' },
      { name: 'quantity', key: 'quantity'},
      { name: 'issuer', key: 'issuer'},
      { name: 'proceeds', key: 'proceeds'},
      { name: 'min Denom', key: 'minDenom'},
      { name: 'muni sec type', key: 'muniSecType' },
      { name: 'fed tax status', key: 'federalTaxStatus'},
      { name: 'state tax status', key: 'stateTaxStatus'},
      { name: 'put indicator', key: 'putIndicator'},
      { name: 'issue date', key: 'issueDate'},
      { name: 'sink indicator', key: 'sinkIndicator'},
      { name: 'S&P Rating', key: 'ratingSP'},
]